// extracted by mini-css-extract-plugin
export var buttonRoot = "iQhL0";
export var buttonTextContainer = "C5gix";
export var headerContainer = "fcGkW";
export var hidden = "q1qAt";
export var horizontalContainer = "JN6b4";
export var iconColor = "Ln6gW";
export var myBookingsAppLogo = "Cgp0O";
export var myBookingsButton = "mrDPE";
export var myBookingsButtonIcon = "UEFxj";
export var myBookingsButtonText = "MnRCK";